( function ( $ ) {
	class Carousel {

		/**
		 * Constructor.
		 *
		 * @return {void}
		 */
		constructor() {

			const bodyEl = $( 'body' );

			// Initialize slider only on 'Audience Home page', 'Single Stories page'
			if (
				bodyEl.hasClass( 'post-type-archive-audiences' ) ||
				bodyEl.hasClass( 'single-stories' ) ||
				bodyEl.hasClass( 'home' ) ||
				bodyEl.hasClass( 'single-post' ) ||
				bodyEl.hasClass( 'page' )
			) {
				this.initializeCarousels();
			}
		}

		/**
		 * Initialize Carousels
		 */
		initializeCarousels() {

			const textCarousel = $('.text-carousel-container');

			if ( textCarousel ) {
				// Text Carousel.
				textCarousel.slick({
					dots: false,
					infinite: true,
					speed: 300,
					autoplay: true,
					pauseOnHover: true,
					slidesToShow: 3,
					prevArrow: '<button class="prev-nav-btn"><span class="prev-nav-arrow"><span></span></span></button>',
					nextArrow: '<button class="next-nav-btn"><span class="next-nav-arrow"><span></span></span></button>',
					responsive: [
						{
							breakpoint: 600,
							settings: {
								slidesToShow: 1
							}
						},
					]
				});
			}
		}

	}

	$( document ).ready( function() {
		new Carousel();

		// All sliders.
		const slideContent = $( '.wp-block-eedee-block-gutenslide.slick-slide' );
		// When hovering over sliders.
		slideContent.hover( function( e ) {
			handleSliderHover( $( this ), e );
		}, function() {
			// Event for mouse out.
			slideContent.removeClass( 'cursor-right' ).removeClass( 'cursor-left' );
		} );

		// When moving mouse on sliders.
		slideContent.mousemove( function( e ) {
			handleSliderHover( $( this ), e );
		} );

		// When clicking on a slide.
		slideContent.click( function() {
			const elem = $( this );
			if ( elem.hasClass( 'cursor-right' ) ) {
				elem.closest( '.slick-slider' ).find( 'button.slick-next' ).trigger( 'click' );
			} else if ( elem.hasClass( 'cursor-left' ) ) {
				elem.closest( '.slick-slider' ).find( 'button.slick-prev' ).trigger( 'click' );
			}

			elem.removeClass( 'cursor-right' ).removeClass( 'cursor-left' );
		} );

		/**
		 * Handler of hover and mousemove events on slider.
		 *
		 * @param {object} elem Slider element.
		 * @param {object} evt  Event object.
		 *
		 * @return {void}
		 */
		const handleSliderHover = ( elem, evt ) => {
			const width = elem.width();
			const finalPosition = evt.pageX - elem.offset().left;

			if ( finalPosition > width / 2 ) {
				elem.removeClass( 'cursor-left' );
				elem.addClass( 'cursor-right' );
			} else {
				elem.addClass( 'cursor-left' );
				elem.removeClass( 'cursor-right' );
			}
		};
	} );

} )( jQuery );
